// extracted by mini-css-extract-plugin
module.exports = {"hero":"styles_hero__yi0DY","hero__content":"styles_hero__content__We8kN","hero__img":"styles_hero__img__HKcHm"};